import "./typography.scss";
import React from "react";
import PropTypes from "prop-types";

const Typography = ({ tag, size, weight, customClass, children, ...props }) => {
  const Component = tag || "p";

  return (
    <Component
      className={`sb-typography${size ? ` sb-typography--${size}` : ""}${
        weight ? ` sb-typography--${weight}` : ""
      }${customClass ? ` ${customClass}` : ""}`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Typography;

Typography.propTypes = {
  tag: PropTypes.string,
  customClass: PropTypes.string,
  size: PropTypes.oneOf([
    "text-xs",
    "text-sm",
    "text-md",
    "heading-sm",
    "heading-md",
    "heading-lg",
    "display-md",
    "display-lg",
    "display-xl",
    "display-xxl",
    "display-xxxl",
  ]),
  weight: PropTypes.oneOf(["regular", "medium", "semibold", "bold"]),
};

Typography.defaultProps = {
  tag: "p",
  size: "text-md",
  weight: "regular",
};
